<script>
import { Helper } from '@/mixin/helper'
import McGraphqlEditableTable from '@/components/McGraphqlEditableTable'
import { GET_CATEGORY } from '@/services/api/setting/fleet/fleetCat'
import { GET_MODEL } from '@/services/api/setting/fleet/fleetModel'
import { GET_FUEL_NAME } from '@/services/api/setting/fleet/fuelType'

import {
  GET_VEHICLE_TYPE,
  GET_VEHICLE_TYPE_DETAIL,
  VEHICLE_TYPE_MUTATION_UPDATE,
  VEHICLE_TYPE_MUTATION_CREATE,
} from '@/services/api/setting/fleet/fleetType'

export default {
  components: {
    McGraphqlEditableTable,
  },
  mixins: [Helper],
  props: {
    status: String,
  },
  data() {
    return {
      data: [],
      transmissionTypeOptions: [
        { key: 'A', label: 'Otomatis' },
        { key: 'M', label: 'Manual' },
      ],
      exception: ['fuelType'],
    }
  },
  computed: {
    /**
     * Management Field for b-table
     */
    fields() {
      return [
        {
          key: 'type',
          label: this.$t('setting.list.fleetSetting.fleetType'),
          placeholder: this.$t('setting.list.fleetSetting.fleetType'),
          thClass: 'mc-table--170',
          isSortable: true,
          isEditable: true,
          validation: [['required']],
        },
        {
          key: 'manufacturer',
          label: 'Manufaktur',
          thClass: 'mc-table--170',
          placeholder: 'Pilih Manufaktur',
          isEditable: true,
          isSortable: false,
          type: 'select-resourceful',
          trackBy: 'model',
          optionsGetter: this.resourcefulQuery.vehicleModels,
          optionLabelFn: ({ item }) => item.model,
          getInitialObject: (item) => {
            return { model: item.manufacturer }
          },
          customValueFn: (item) => (item.manufacturer ? item.manufacturer : ''),
          validation: [['required']],
        },
        {
          key: 'category',
          label: this.$t('setting.list.fleetSetting.fleetCategory'),
          thClass: 'mc-table--170',
          placeholder: 'Pilih Kategori Kendaraan',
          isEditable: true,
          isSortable: false,
          type: 'select-resourceful',
          trackBy: 'category',
          optionsGetter: this.resourcefulQuery.vehicleCategories,
          optionLabelFn: ({ item }) => item.category,
          getInitialObject: (item) => {
            return {
              category: item.category,
            }
          },
          customValueFn: (item) => item.category ?? '',
        },
        {
          key: 'tonnage',
          label: this.$t('setting.list.fleetSetting.tonage'),
          placeholder: 'Berat Kosong',
          thClass: 'mc-table--150',
          isSortable: false,
          isEditable: true,
          type: 'number',
        },
        {
          key: 'volume',
          label: 'Volume (Cbm)',
          placeholder: 'Volume',
          thClass: 'mc-table--130',
          isSortable: false,
          isEditable: true,
          type: 'number',
        },
        {
          key: 'fuelEfficiency',
          label: 'Efisiensi (Km/L)',
          placeholder: 'Efisiensi',
          thClass: 'mc-table--150',
          isSortable: false,
          isEditable: true,
          type: 'number',
          min: 0,
          step: '0.01',
        },
        {
          key: 'fuelType',
          label: 'Bahan Bakar',
          thClass: 'mc-table--170',
          placeholder: 'Pilih Bahan Bakar',
          isSortable: false,
          isEditable: true,
          type: 'select-resourceful',
          trackBy: 'fuelTypeId',
          optionsGetter: this.resourcefulQuery.fuelType,
          optionLabelFn: ({ item }) => item.name,
          getInitialObject: (item) => {
            return { fuelTypeId: item.fuelTypeId, name: item.fuelType }
          },
          customValueFn: (item) => item.fuelTypeId ?? '',
          validation: [['required']],
        },
        {
          key: 'transmissionType',
          label: 'Transmisi',
          thClass: 'mc-table--130',
          placeholder: 'Pilih Transmisi',
          isEditable: true,
          isSortable: false,
          type: 'select-resourceful',
          trackBy: 'key',
          optionsGetter: this.resourcefulQuery.transmissionType,
          optionLabelFn: ({ item }) => item.label,
          getInitialObject: (item) => {
            return {
              key: item.transmissionTypeKey,
              label: item.transmissionType,
            }
          },
          customValueFn: (item) => item.transmissionTypeKey ?? '',
          thStyle: 'width: 300px',
          validation: [['required']],
        },
      ]
    },

    query() {
      return {
        get: async (filter) => {
          filter.isActive = true
          const res = await this.$apollo.query({
            fetchPolicy: 'no-cache',
            query: GET_VEHICLE_TYPE,
            variables: {
              filter: filter,
            },
          })
          let self = this

          let result = res.data.vehicleTypes.vehicleTypes
          result.data.forEach((item, index) => {
            if (item.companyId == 1 || item.hasRelation) {
              result.data[index].disableCheckbox = true
            }
            const transmissionType = this.transmissionTypeOptions.find(
              (itemTrans) => itemTrans.key == item.transmissionType
            )
            result.data[index].manufacturer = `${item.manufacturer} - ${item.model}`
            result.data[index].transmissionTypeKey = item.transmissionType
            result.data[index].transmissionType = transmissionType.label
            result.data[index].fuelTypeId = item.fuelType?.fuelTypeId
            result.data[index].fuelType = item.fuelType?.name
          })
          self.data = result.data

          return result
        },
        store: async (data) => {
          const arr = data.manufacturer.split(' - ')
          const res = await this.$apollo.mutate({
            mutation: VEHICLE_TYPE_MUTATION_CREATE,
            variables: {
              input: {
                type: data.type,
                manufacturer: arr[0],
                model: arr[1],
                category: data.category || null,
                tonnage: parseFloat(data.tonnage) || 0,
                volume: parseFloat(data.volume) || 0,
                fuelType: data.fuelType || '',
                transmissionType: data.transmissionType || '',
                fuelEfficiency: parseFloat(data.fuelEfficiency) || 0,
              },
            },
          })
          if (
            res.data.createVehicleType.message.toLowerCase().includes('vehicle type already exists')
          ) {
            this.$mcToast.warning('Jenis kendaraan sudah digunakan')
            return
          }
          let self = this
          const showData = await this.$apollo.query({
            query: GET_VEHICLE_TYPE_DETAIL,
            fetchPolicy: 'no-cache',
            variables: {
              filter: { vehicleTypeId: res.data.createVehicleType.vehicleType.vehicleTypeId },
            },
          })
          let newData = showData.data.vehicleType.vehicleType
          newData.hasRelation = false
          const transmissionType = this.transmissionTypeOptions.find(
            (itemTrans) => itemTrans.key == newData.transmissionType
          )
          newData.manufacturer = `${newData.manufacturer} - ${newData.model}`
          newData.transmissionTypeKey = newData.transmissionType
          newData.transmissionType = transmissionType.label
          newData.fuelTypeId = newData.fuelType?.fuelTypeId
          newData.fuelType = newData.fuelType?.name
          self.data.push(newData)

          return newData
        },
        update: async (id, oldData, newData) => {
          const manufacturer = newData.manufacturer || oldData.manufacturer
          const arr = manufacturer.split(' - ')
          const res = await this.$apollo.mutate({
            mutation: VEHICLE_TYPE_MUTATION_UPDATE,
            variables: {
              input: {
                vehicleTypeId: Number(id),
                type: newData.type || oldData.type,
                manufacturer: arr[0],
                model: arr[1],
                category: newData.category || oldData.category,
                tonnage: parseFloat(newData.tonnage) || parseFloat(oldData.tonnage),
                volume: parseFloat(newData.volume) || parseFloat(oldData.volume),
                fuelType: newData.fuelType || oldData.fuelTypeId,
                transmissionType: newData.transmissionType || oldData.transmissionTypeKey,
                fuelEfficiency:
                  parseFloat(newData.fuelEfficiency) || parseFloat(oldData.fuelEfficiency),
              },
            },
          })
          if (
            res.data.updateVehicleType.message.toLowerCase().includes('vehicle type already exists')
          ) {
            this.$mcToast.warning('Jenis kendaraan sudah digunakan')
            return
          }

          const showData = await this.$apollo.query({
            query: GET_VEHICLE_TYPE_DETAIL,
            fetchPolicy: 'no-cache',
            variables: {
              filter: { vehicleTypeId: id },
            },
          })
          const updateData = showData.data.vehicleType.vehicleType
          updateData.hasRelation = oldData.hasRelation

          const transmissionType = this.transmissionTypeOptions.find(
            (itemTrans) => itemTrans.key == updateData.transmissionType
          )
          if (updateData.companyId == 1 || updateData.hasRelation) updateData.disableCheckbox = true
          updateData.manufacturer = `${updateData.manufacturer} - ${updateData.model}`
          updateData.transmissionTypeKey = updateData.transmissionType
          updateData.transmissionType = transmissionType.label
          updateData.fuelTypeId = updateData.fuelType?.fuelTypeId
          updateData.fuelType = updateData.fuelType?.name
          return updateData
        },
        delete: async (id) => {
          const res = await this.$apollo.mutate({
            mutation: VEHICLE_TYPE_MUTATION_UPDATE,
            variables: {
              input: {
                vehicleTypeId: Number(id),
                isActive: false,
              },
            },
          })

          return res.data.updateVehicleType.isSuccessful
        },
      }
    },

    resourcefulQuery() {
      return {
        vehicleModels: async (opts) => {
          const filter = {
            search: opts.search,
          }

          const res = await this.$apollo.query({
            fetchPolicy: 'no-cache',
            query: GET_MODEL,
            variables: {
              filter: filter,
            },
          })

          const data = res.data.vehicleModels.vehicleModels
          const result = {
            metadata: {
              total_page: 1,
              total_count: 5,
              page: 1,
            },
            data: {
              paginated_result: data,
            },
          }

          return result
        },
        vehicleCategories: async (opts) => {
          const filter = {
            search: opts.search,
            pagination: {
              page: opts.page,
              show: opts.limit,
            },
          }

          const res = await this.$apollo.query({
            fetchPolicy: 'no-cache',
            query: GET_CATEGORY,
            variables: {
              filter: filter,
            },
          })

          const data = res.data.vehicleCategories.vehicleCategories
          const result = {
            metadata: {
              total_page: Math.ceil(data.pagination.total / data.pagination.show),
              total_count: data.pagination.total,
              count: data.pagination.show,
              page: opts.page,
            },
            data: {
              paginated_result: data.data,
            },
          }
          return result
        },
        fuelType: async (opts) => {
          const filter = {
            pagination: {
              page: opts.page,
              show: opts.limit,
            },
            search: opts.search,
          }

          const res = await this.$apollo.query({
            fetchPolicy: 'no-cache',
            query: GET_FUEL_NAME,
            variables: {
              filter: filter,
            },
          })

          const data = res.data.fuelTypes.fuelTypes
          const result = {
            metadata: {
              total_page: Math.ceil(data.pagination.total / data.pagination.show),
              total_count: data.pagination.total,
              count: data.pagination.show,
              page: opts.page,
            },
            data: {
              paginated_result: data.data,
            },
          }
          return result
        },
        transmissionType: async (opts) => {
          let transmissionTypeOptions = this.transmissionTypeOptions
          if (opts.search) {
            transmissionTypeOptions = transmissionTypeOptions.filter((item) =>
              this.isContains(opts.search, item.label)
            )
          }
          const result = {
            metadata: {
              total_page: 1,
              total_count: transmissionTypeOptions.length,
              page: 1,
            },
            data: {
              paginated_result: transmissionTypeOptions,
            },
          }
          return result
        },
      }
    },
  },
  methods: {
    async handleChange() {
      const fleetTypeRef = this.$refs.fleetTypeRef.$refs
      await this.$nextTick()
      fleetTypeRef['type-ref'].$el.addEventListener('keydown', this.preventTabKey)
      fleetTypeRef['manufacturer-ref'].$el.addEventListener('keydown', this.preventTabKey)
      fleetTypeRef['fuelEfficiency-ref'].$el.addEventListener('keydown', this.preventTabKey)
      fleetTypeRef['fuelType-ref'].$el.addEventListener('keydown', this.preventTabKey)
    },
    preventTabKey(event) {
      if (event.keyCode === 9) {
        // Tab key
        event.preventDefault()
      }
    },
  },
}
</script>

<template>
  <!-- Fleet Type -->
  <b-tab class="border-0" @click="$store.commit('setting/SET_STATUS', status)">
    <template #title>
      <span class="d-sm-inline-block">{{ $t('setting.list.fleetSetting.fleetType') }}</span>
    </template>

    <!-- Table -->
    <div class="table-responsive my-3">
      <McGraphqlEditableTable
        ref="fleetTypeRef"
        :fields="fields"
        :apiClient="query"
        trackBy="vehicleTypeId"
        :isPredefined="true"
        :searchable="true"
        :fieldException="exception"
        @changeData="handleChange"
      />
    </div>
  </b-tab>
</template>
